var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 10,
    height: 10,
    transform: "translate(0 -0.001)",
    fill: "#ffdcdc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 10,
    height: 10,
    transform: "translate(0 -0.001)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    transform: "translate(0.71 0.685)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y2: 7.933,
    transform: "translate(4.066)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M13.133,12,9.066,16.066,5,12",
    transform: "translate(-5 -8.034)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridDescIcon);
export default __webpack_public_path__ + "static/media/grid-desc-icon.2c61731386fbbe478723f88c2f93d29b.svg";
export { ForwardRef as ReactComponent };